module.exports = __webpack_public_path__ + "static/img/A23.c52b9321.jpg";